export class AzureDiskRestoreData {
    'diskId';
    'diskName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskName",
            "baseName": "diskName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
